import { types } from 'mobx-state-tree';

export interface SimpleTableBodyRowProps {
  id: number;
  name: string;
  values: Array<string | boolean>;
}

export const SimpleTableBodyRow = types.model({
  id: types.number,
  name: types.string,
  values: types.optional(
    types.array(types.union(types.string, types.boolean)),
    []
  ),
});
